<template>
  <section class="spartan-home sp-work-order">
    <SpartanHeader />

    <div class="container-wide">
      <div class="content">
        <SpartanNavigation />

        <div class="banner">
          <picture>
            <source
              media="(max-width:480px)"
              srcset="../assets/spartan-banners/spartan-work-order-square.jpg"
              alt="contact Spartan Builders"
            />
            <source
              media="(min-width:480px)"
              srcset="../assets/spartan-banners/spartan-work-order.jpg"
              alt="contact Spartan Builders"
            />
            <img
              src="../assets/spartan-banners/spartan-work-order.jpg"
              alt="contact Spartan Builders"
            >
         </picture>
          
        </div>

        <div class="copy">
          <h2>Work Order</h2>
          <p>
            Please fill out the fields below for the project you need help with
            and we will be in touch with you as soon as we have had a chance to
            review your information.
          </p>
          <form action="https://www.elformo.com/forms/718ecdcd-bd44-475c-b608-67e135c0c2ac" method="post" accept-charset="UTF-8">
            <input id="elformo_honeypot" name="elformo_honeypot" />
            <div class="input-group">
              <label for="lblContactName">name</label>
              <input type="text" name="contactName" />
            </div>

            <div class="input-group">
              <label for="lblAddress">address</label>
              <input type="text" name="address" />
            </div>

            <div class="input-group">
              <label for="lblCityStateZip">city/state/zip</label>
              <input type="text" name="cityStateZip" />
            </div>

            <div class="input-group">
              <label for="lblcell">cell phone</label>
              <input type="tel" name="cell" />
            </div>

            <div class="input-group">
              <label for="lblQuestion">question</label>
              <textarea name="question" cols="30" rows="10"></textarea>
            </div>

            <div class="form-submit">
              <button type="submit" class="btn-primary">
                Send Us Your Work Order
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <SpartanFooter />
  </section>
</template>

<script>
import SpartanHeader from "@/components/SpartanHeader.vue";
import SpartanNavigation from "@/components/SpartanNavigation.vue";
import SpartanFooter from "@/components/SpartanFooter.vue";

export default {
  name: "SpartanHome",
  components: {
    SpartanHeader,
    SpartanNavigation,
    SpartanFooter
  }
};
</script>

<style lang="scss">
#elformo_honeypot {
  display: none;
}
.content {
  background: #7a7a75;
  min-height: 50vh;
}

.section-link {
  text-decoration: none;
}

.section-link:link,
.section-link:visited {
  color: #fff;
}

.banner {
  width: 100%;
}

.banner > img,
.banner > picture {
  width: 100%;
  height: auto;
}
</style>
